import { style } from '@vanilla-extract/css';
import { themeVars, nToPx } from '@tundr/theme';

export const sidePanelSkeletonContainerClass = style({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  width: '100%',
  height: '100%',
  gap: themeVars.space.x4,
});

export const sidePanelContentClass = style({
  width: '100%',
  overflowY: 'auto',
  flex: 1,
  padding: themeVars.space.x1,
});

export const sidePanelHeaderClass = style({
  width: '100%',
  flex: 0,
  padding: nToPx(themeVars.space.x2, 0),
});

export const sidePanelFooterClass = style({
  width: '100%',
  flex: 0,
  padding: nToPx(themeVars.space.x2, 0),
});
